const LocationSection = () => {
    return (
      <section id="location" className="w-full">
        <div className="relative w-full h-[400px]">
          <iframe
            title="Well Fitness Czechowice-Dziedzice"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10305.219464653667!2d18.988891!3d49.910052!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47142b139b2b66f3%3A0x76c273d27d57d17b!2sWell%20Fitness!5e0!3m2!1spl!2spl!4v1714933006000!5m2!1spl!2spl"
            className="w-full h-full border-0 grayscale contrast-100"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    );
  };
  
  export default LocationSection;
  